export default __webpack_public_path__ + "static/media/profile-active.5b036a21.png";